<div *ngIf="message" class="position-fixed top-0 end-0 p-3 z-3" style="z-index: 1050;">
    <div class="toast show w-auto px-3 align-items-center text-white" [ngClass]="type === 'success' ? 'bg-success' : 'bg-danger'"
        role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
            <div class="toast-body fs-4 fw-semibold">
                {{ message }}
            </div>
            <button type="button" class="btn-close btn-close-white me-3 m-auto" aria-label="Close"
                (click)="message = null"></button>
        </div>
    </div>
</div>